// extracted by mini-css-extract-plugin
export default {"landingpage":"LandingPage_landingpage__C0VsI"};